export const colors = {
  CRIADO: {
    primary: '#1e90ff', //AZUL
    secondary: '#1e90ff'
  },
  CANCELADA: {
    primary: '#ff0000', //VERMELHO
    secondary: '#ff0000'
  },
  EM_ANDAMENTO: {
    primary: '#9333EA', //ROXO
    secondary: '#9333EA'
  },
  CONCLUIDA: {
    primary: '#008000', //VERDE
    secondary: '#008000'
  }
};
